define('gigaset_stocknotification/components/product/list',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/components/Dispatcher",
	"json!gigaset_stocknotification/handles/gigaset_stocknotification.json"
], function(
	$,
	_,
	Component,
	ComponentDispatcher,
	Handles
) {
	return Component.create({
		$init: function() {
			$(document).on("cartware_cart/modal/open", function() {
				new ComponentDispatcher({
					handles: ["catalog_product_view", "PRODUCT_TYPE_configurable"],
					apply: Handles
				});
			});
		}
	});
});

